import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React from "react";
import { useLocation } from "react-router-dom";
import FormatAlignRightIcon from "@mui/icons-material/FormatAlignRight";
import { menus } from "./menus";

const DrawerSm = ({ handleMenuClick }) => {
  const [state, setState] = React.useState({
    top: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      className="secondary-bg"
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {menus.map((item) => (
          <ListItem key={item.name} disablePadding>
            <ListItemButton onClick={() => handleMenuClick(item?.link)}>
              <ListItemIcon
                sx={{
                  color: "white",
                  minWidth: 0,
                  justifyContent: "center",
                  mr: 1,
                }}
              >
                {<item.icon />}
              </ListItemIcon>
              <ListItemText sx={{ color: "white" }} primary={item.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <div>
      <IconButton
        onClick={toggleDrawer("top", true)}
        size="large"
        edge="start"
        aria-label="menu"
        sx={{ color: "white", mr: 2 }}
      >
        <FormatAlignRightIcon />
      </IconButton>
      <Drawer
        anchor="top"
        open={state["top"]}
        onClose={toggleDrawer("top", false)}
      >
        {list("top")}
      </Drawer>
    </div>
  );
};

export default DrawerSm;
